import script from "./widgetCustom.vue?vue&type=script&lang=js"
export * from "./widgetCustom.vue?vue&type=script&lang=js"

import "./widgetCustom.vue?vue&type=style&index=0&id=afc9c876&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-afc9c876"],['__file',"src/components/widgets/widgetCustom.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "afc9c876"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('afc9c876', __exports__)) {
    api.reload('afc9c876', __exports__)
  }
  
}


export default __exports__